import { render, staticRenderFns } from "./Attachments_Global_Progress_UI.vue?vue&type=template&id=134c6ca7&"
import script from "./Attachments_Global_Progress_UI.vue?vue&type=script&lang=js&"
export * from "./Attachments_Global_Progress_UI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports